export enum MutationTypes {
  SET_USER_LOCATIONS = "users-module/set-user-locations",
  SET_INSPECTORS = "users-module/set-user-inspects",
  SET_USERS = "users-module/set-users",
  SET_USERS_META = "users-module/set-users-meta",
  SET_USERS_FOR_ASSIGN = "users-module/set-users-for-assign",
}
